import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaCheckCircle, FaExchangeAlt } from "react-icons/fa";
import { HiPlusCircle, HiSparkles } from "react-icons/hi2";
import { GoHome } from "react-icons/go";
import { AiOutlineUser } from "react-icons/ai";
import { MdOutlineLogout, MdOutlineSecurity } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import { UseAuth } from "src/auth/AuthContext";
import ConfirmationLogout from "../Shared/ConfirmationLogout";
import { BsFillKeyFill } from "react-icons/bs";
import { RiBankCardFill } from "react-icons/ri";
import {
  classNames,
  getProfileDefaultImage,
  validateRouteRole,
} from "src/helpers/mixins";
import { FaUserGear } from "react-icons/fa6";
import { Tooltip } from "antd";
import { IoAlert } from "react-icons/io5";
import { SiHtmlacademy } from "react-icons/si";
import { GrHelp, GrHelpBook } from "react-icons/gr";

interface Props {
  showMenu: boolean;
  closeMenu: () => void;
}

const SideBar = ({ showMenu }: Props) => {
  const { user } = UseAuth();
  const [showConfirmationLogout, setShowConfirmationLogout] =
    useState<boolean>(false);
  const navigate = useNavigate();

 
  const getValidationKYC = (kyc: boolean) => {
    if (kyc) {
      return (
        <Tooltip color="#000" title={"Perfil verificado"}>
          <FaCheckCircle className="text-sky-400 cursor-pointer" size={15} />
        </Tooltip>
      );
    } else {
      return (
        <Tooltip
          title={
            <div>
              KYC Vacio <div>Presiona para gestionar</div>
            </div>
          }
          placement="bottomRight"
          color="#000"
        >
          <IoAlert
            onClick={() => navigate(`/usuario/${user?.id}/verificaridentidad`)}
            size={33}
            className="text-red-400 cursor-pointer"
          />
        </Tooltip>
      );
    }
  };

  return (
    <div
      className={`${
        !showMenu && "hidden md:block"
      } w-full md:w-fit  bg-green-sidebar flex-shrink flex-grow-0  min-h-screen`}
      style={{ zIndex: 900 }}
    >

      
      <div
        className="w-full absolute md:w-64 md:fixed bg-white"
        
      > 
        <div className="transition-all gap-2 border-l-transparent border-l-8 flex md:flex-row items-center justify-start text-black py-4 px-8 cursor-pointer font-semibold w-full md:w-64">
          <div
            className="w-6 h-6 bg-cover bg-center rounded-full"
            onClick={() => navigate("/usuario/" + user?.id)}
            style={{
              backgroundImage: `url(${
                (user?.photoUrl?.length || 0) > 0
                  ? process.env.REACT_APP_PROFILEPICTURE +
                    (user?.photoUrl || "")
                  : getProfileDefaultImage()
              })`,
            }}
          ></div>

          <div className="ellipsis max-w-90 flex items-center gap-1 font-bold text-sm">
            <Tooltip
              title={<div className="cursor-pointer">Perfil de usuario</div>}
              placement="left"
              color="#000"
            >
              <span
                onClick={() => navigate("/usuario/" + user?.id)}
                className="cursor-pointer font-medium  hover:underline"
              >
                {user?.fullname?.split(" ")[0]}
              </span>
            </Tooltip>

            {getValidationKYC(user?.verifiedIdentity || false)}
          </div>
        </div>
        <MenuListedClient size="sm" close={() => null} />
      </div>
      <ConfirmationLogout
        show={showConfirmationLogout}
        cancel={() => setShowConfirmationLogout(false)}
        confirm={() => navigate('/salir')}
      />
    </div>
  );
};
export default SideBar;

type ParamsMenuLClient = {
  close(): void;
  size:string
};
export const MenuListedClient = ({ close,size}: ParamsMenuLClient) => {
  const { user } = UseAuth();
  const { t } = useTranslation();
  const location = useLocation();
  const pathName = location.pathname.toString();
  const role = user?.role || "user";
  const enableRoutes = validateRouteRole(role);
  const navigate = useNavigate();
  const go = (to: string) => {
    close();
    navigate(to);
  };

  return (
    <ul 
    className="relative md:sticky  h-full -top-8 md:top-0  transition-all">
      <LiDev
        name={t("sidebar.home")}
        to="/inicio"
        pathName={pathName}
        go={go}
        size={size}
        Icon={
          <>
            <GoHome size={20} className="text-black" />
          </>
        }
      />
      <LiDev
        name={t("sidebar.profile")}
        to={`/usuario/${user?.id}`}
        pathName={pathName}
        go={go}
        size={size}
        Icon={
          <>
            <AiOutlineUser size={20} className="text-black" />
          </>
        }
      />
      <LiDev
        name={t("sidebar.cashier")}
        to="/elegir-cajero"
        pathName={pathName}
        go={go}
        size={size}
        Icon={
          <>
            <FaUserGear size={20} className="text-black" />
          </>
        }
      />
      
      {/* Nueva Transferencia - Botón Destacado */}
      <li className="mx-3 my-2">
        <div
          className={classNames(
            pathName.toString().includes("/transferir")
              ? 'bg-gradient-to-r from-emerald-500 to-emerald-600 shadow-lg'
              : 'bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 shadow-md hover:shadow-lg',
            "transition-all duration-200 transform hover:scale-[1.02] rounded-lg cursor-pointer font-bold"
          )}
          onClick={() => go("/transferir")}
        >
          <div className="flex items-center justify-center gap-2 px-3 py-2.5 text-white">
            <div className="relative">
              <div className="relative bg-white/20 rounded-full p-1.5">
                <HiPlusCircle size={18} className="text-white" />
              </div>
            </div>
            <div className="flex-1">
              <div className="text-xs font-bold uppercase tracking-wide leading-tight">
                {t("sidebar.newtransfer")}
              </div>
            </div>
            {!pathName.toString().includes("/transferir") && (
              <HiSparkles size={14} className="text-white/80 animate-pulse" />
            )}
          </div>
        </div>
      </li>

      <LiDev
        name={t("sidebar.account")}
        to="/mis-cuentas"
        pathName={pathName}
        go={go}
        size={size}
        Icon={
          <>
            <RiBankCardFill size={20} className="text-black" />
          </>
        }
      />  
          
      <LiDev 
            name={t('academytext')} 
            to="/aprender"
            go={go}
            size={size}
            pathName={pathName}
            Icon={<><SiHtmlacademy size={20} className='text-stone-500' /></>}
          />        



      <LiDev
        name={t("sidebar.support")}
        to="/ayuda"
        pathName={pathName}
        go={go}
        size={size}
        Icon={
          <>
            <GrHelpBook size={20} className="text-black" />
          </>
        }
      />

      <LiDev
        name={t("sidebar.security")}
        to="/seguridad"
        pathName={pathName}
        go={go}
        size={size}
        Icon={
          <>
            <MdOutlineSecurity size={20} className="text-black" />
          </>
        }
      />

      {(enableRoutes.includes("*") || enableRoutes.includes("/admin")) && (
        <LiDev
          name={t("sidebar.admin")}
          to="/admin"
          pathName={pathName}
          go={go}
          size={size}
          Icon={
            <>
              <BsFillKeyFill size={20} className="text-black" />
            </>
          }
        />
      )}
      <LiDev
        name={t("exit")}
        to="/salir"
        pathName={pathName}
        go={go}
        size={size}
        Icon={
          <>
            <MdOutlineLogout size={20} className="text-black" />
          </>
        }
      />
    </ul>
  );
};
type ParamsLiDev = {
  name: string;
  to: string;
  Icon: any;
  pathName: any;
  go(to: string): void;
  size: string
};
const LiDev = ({ name, to, Icon, pathName, go,size }: ParamsLiDev) => {
  return (
    <li>
      <div
        className={classNames(
          pathName.toString().includes(to)
          ? 'bg-[#f3f4f6] border-l-green-admin-light' 
          :
           'md:bg-transparent border-l-transparent',
           (size === 'small') ? 'py-1.5':'py-4',
          "transition-all border-l-transparent border-l-8 flex md:flex-row items-center justify-start  text-black  px-8 cursor-pointer font-semibold w-full md:w-64"
          
        )}
        onClick={() => go(to)}
      >
        <div className="flex flex-wrap flex-col text-[#222] items-center text-center">
          {Icon}
        </div>
        <span className={classNames(size === "small" ? 'text-xs': 'text-base', "font-medium px-4 opensans md:text-sm text-[#222]")}>
          {name}
        </span>
      </div>
    </li>
  );
};
